import * as React from 'react';

import { Link } from 'libs/router';

import type { SidePanelItem } from 'types';

type Props = {
  item: SidePanelItem
};

const SidePanelItemLink = ({
  item
}: Props) => (
  <Link
    to={item.link}
    rel="noopener noreferrer"
    target="_blank"
  >
    {item.text}
  </Link>
);

export default SidePanelItemLink;
